import Navbar from '../components/feature/Navbar';
import Footer from '../components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex flex-col">
      <Navbar />
      
      <div className="flex-1 flex items-center justify-center px-4 pt-20">
        <div className="text-center max-w-2xl">
          {/* Animated Space Theme */}
          <div className="relative mb-12">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-96 h-96 bg-gradient-to-r from-[#00f0ff]/20 to-[#a855f7]/20 rounded-full blur-3xl animate-pulse"></div>
            </div>
            <div className="relative">
              <div className="text-9xl font-bold mb-4 bg-gradient-to-r from-[#00f0ff] to-[#a855f7] bg-clip-text text-transparent animate-gradient">
                404
              </div>
              <div className="flex items-center justify-center gap-4 mb-8">
                <i className="ri-rocket-2-line text-6xl text-[#00f0ff] animate-bounce"></i>
                <i className="ri-planet-line text-5xl text-[#a855f7] animate-pulse"></i>
                <i className="ri-star-fill text-4xl text-[#00f0ff] animate-ping"></i>
              </div>
            </div>
          </div>

          <h1 className="text-5xl font-bold mb-6">Lost in Space</h1>
          <p className="text-xl text-gray-400 mb-8 leading-relaxed">
            Oops! Looks like you've drifted into uncharted territory. The page you're looking for doesn't exist in our universe.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/"
              className="inline-block bg-gradient-to-r from-[#00f0ff] to-[#a855f7] px-10 py-5 rounded-xl font-semibold text-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-line mr-2"></i>
              Return to Earth (Home)
            </a>
            <a
              href="/jobs"
              className="inline-block bg-[#1a1a1a] border-2 border-[#00f0ff] px-10 py-5 rounded-xl font-semibold text-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-line mr-2"></i>
              Browse Jobs
            </a>
          </div>

          {/* Floating Elements */}
          <div className="mt-16 flex items-center justify-center gap-8 text-gray-500">
            <i className="ri-meteor-line text-3xl animate-bounce" style={{ animationDelay: '0s' }}></i>
            <i className="ri-space-ship-line text-4xl animate-bounce" style={{ animationDelay: '0.2s' }}></i>
            <i className="ri-earth-line text-3xl animate-bounce" style={{ animationDelay: '0.4s' }}></i>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
